import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { getHighestIndexOrPercent } from '../../../util/Insight360Utils';
import AttitudesSinglePersonaDetail from './AttitudesSinglePersonaDetail';

class AttitudesSinglePersona extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRadioButton: 'index',
    };
  }

  render() {
    let attitudeList = [];
    let highestIndex = 0;
    if (
      this.props.attitudes !== undefined &&
      this.props.attitudes[0].attitudeGroups !== undefined &&
      this.props.insight360AttitudeAgreeChoice !== undefined
    ) {
      const attitudeGroup = _.find(
        this.props.attitudes[0].attitudeGroups,
        this.props.insight360AttitudeAgreeChoice,
      );
      if (attitudeGroup !== undefined) {
        attitudeList = attitudeGroup[this.props.insight360AttitudeAgreeChoice];
        highestIndex = getHighestIndexOrPercent(
          attitudeList,
          this.state.selectedRadioButton,
        );
      }
    }
    return (
      <div className="row fullwidth attitudeSinglePersonaCardPdf">
        <div className="large-1 medium-1 small-1 columns">
          <span>&nbsp;</span>
        </div>
        <div
          className="large-10 medium-10 small-10 columns"
          id="attitudePersonaGrid"
        >
          <div className="row fullwidth">
            {this.props.attitudes !== undefined &&
              this.props.attitudes[0].attitudeGroups !== undefined &&
              !_.isEmpty(attitudeList) &&
              attitudeList.length > 0 &&
              attitudeList.map((attitude, i) => (<div className="row fullwidth" key={`att-s${i}`}>
                <div className="columns large-12 small-12 medium-12">
                  {
                    <AttitudesSinglePersonaDetail
                      highestIndex={highestIndex}
                      attitudeDetail={attitude}
                      selectedIcon={_.camelCase(
                        attitude.icon.replace('.png', ''),
                      )}
                      selectedTab={this.props.selectedTab}
                      personaIndex={0}
                      studyName={this.props.studyName}
                    />
                  }
                </div>
              </div>
              )
              )}
          </div>
        </div>
        <div className="large-1 medium-1 small-1 columns">
          <span>&nbsp;</span>
        </div>
      </div>
    );
  }
}

AttitudesSinglePersona.propTypes = {
  attitudes: PropTypes.arrayOf(PropTypes.object),
  insight360AttitudeAgreeChoice: PropTypes.string,
  selectedTab: PropTypes.string,
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(AttitudesSinglePersona);
